import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMSmallTable } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { theme } from "../../../theme";

/** Adds the audit information card (#2222). */
export function addAuditCard(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";

  const auditComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "auditComponent",
      labels: ["audit"],
      description:
        getLocalizedMessage(language, "auditComponent.description") ||
        "Shows the audit information.",
      title:
        getLocalizedMessage(language, "auditComponent.title") ||
        "Audit Information",
    },
  });

  auditComponent.mapState(({ currentReport, settings }) => {
    return {
      showInfoIcon: false,
      showMenuIcon: false,
      title: `Audit Information`,
      icon: "InfoOutlined",
      items: [
        {
          label: `${
            settings?.configuration?.fieldsDefinition?.find(
              (field) => field.fieldName === "secondCategory"
            )?.label ?? "Audit Type"
          }`,
          value: currentReport?.project?.secondCategory ?? "",
          chipColor: theme.palette.secondary.main,
          chipTextColor: theme.palette.primary.main,
        },
        {
          label: `Audit Title`,
          value: currentReport?.project?.freeTextFieldOne ?? "",
          chipColor: theme.palette.secondary.main,
          chipTextColor: theme.palette.primary.main,
          cutValueAfter: 18,
        },
      ],
      fixedHeight: "134px",
    };
  });

  auditComponent.mapVisibility(({ settings }) =>
    (
      settings?.configuration?.fieldsDefinition?.filter(
        (field) => field.purpose === "projectBasic"
      ) ?? []
    ).some(
      (field) =>
        field.enabled === true &&
        (field.fieldName === "secondCategory" ||
          field.fieldName === "freeTextFieldOne")
    )
  );
}
